import styled from "styled-components";
import { motion } from "framer-motion";

export const FormTitle = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: var(--primary-color);
`;

export const FormColumn = styled.div`
  padding: 50px;
  background: var(--white-background-color);
  border: 20px;
  flex: 1;
  max-width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    max-width: 100% !important;
    flex-basis: 100%;
  }

  img {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
`;

export const FormWrapper = styled.form`
  /* max-width: 540px; */
  padding-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 100%; */
`;

export const FormMessage = styled(motion.div)`
  color: var(--error-text-color);
  padding: 5px;
  text-align: center;
  margin-top: 1rem;
`;

export const FormInputRow = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 1.4rem;

  > p {
    font-size: 0.8rem;
    margin-top: 0.5rem;
    color: var(--error-text-color);
  }
`;

export const FormInput = styled.input`
  display: block;
  padding-left: 10px;
  outline: none;
  border-radius: 5px;
  height: 3rem;
  width: 20rem;
  resize: none;
  outline: none;
  border: 1px solid var(--inactive-border-color);
  background-color: var(--form-background-color);
  font-size: 1.1rem;
  /* font: "Inter", sans-serif; */

  &:focus {
    border-color: var(--active-border-color);
  }
`;

export const FormLabel = styled.label`
  height: 25%;
  width: 100%;
  display: inline-block;
  font-size: 1.1rem;
  color: #606060;
  /* text-align: start; */
  /* z-index: 10; */
  /* background-color: #ffffff; */
  margin-left: 5px;
`;

// 23-Sep
export const Button = styled.button`
  border-radius: 5px;
  background: linear-gradient(
    to bottom,
    var(--primary-color),
    var(--secondary-color)
  );
  /* margin: 10px 0px; */
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  /* width: 10rem; */
  width: 100%;
  height: 100%;
  /* font-size: 1rem; */
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  color: var(--text-light-color);
  border: none;

  &:disabled {
    color: var(--text-light-color);
    background: var(--disabled-border-color);
    font-weight: 500;
    cursor: default;
  }
  /* &:hover {
    color: var(--hover-color);
     font-weight: 500; 
  } */
`;

// 23-Sep
export const DeleteButton = styled.button`
  border-radius: 5px;
  background: #a52a2a;
  /* margin: 10px 0px; */
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  /* width: 10rem; */
  width: 100%;
  height: 100%;
  /* font-size: 1rem; */
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  color: var(--text-light-color);
  border: none;

  &:disabled {
    color: var(--text-light-color);
    background: var(--disabled-border-color);
    font-weight: 500;
    cursor: default;
  }
  /* &:hover {
    color: var(--hover-color);
     font-weight: 500; 
  } */
`;

export const SecondaryButton = styled.button`
  border-radius: 5px;
  background: linear-gradient(
    to bottom,
    var(--hover-color),
    var(--hover-color)
  );
  /* margin: 10px 0px; */
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  /* width: 10rem; */
  width: 100%;
  height: 100%;
  /* font-size: 1rem; */
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  color: var(--text-light-color);
  border: none;

  /* &:hover {
    color: var(--hover-color);
     font-weight: 500; 
  } */
`;

export const SecondaryWhiteButton = styled.button`
  border-radius: 5px;
  /* background: linear-gradient(
    to bottom,
    var(--hover-color),
    var(--hover-color)
  ); */
  /* margin: 10px 0px; */
  white-space: nowrap;
  /* outline: solid; */
  cursor: pointer;
  /* width: 10rem; */
  /* width: 100%;
  height: 100%; */
  /* font-size: 1rem; */
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  /* color: var(--link-text-color); */
  color: white;
  border-color: #2196f3;
  border: 1px solid #2196f3;
  background-color: #2196f3;
  /* Additional styles when button is disabled */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5; /* Adjust opacity as needed */
  }

  &:hover {
    color: #2196f3;
    font-weight: 500;
    background: linear-gradient(
      to bottom,
      var(--hover-color),
      var(--hover-color)
    );
  }
`;

export const SecondaryBlueButton = styled.button`
  border-radius: 5px;
  background: #2196f3;
  /* margin: 10px 0px; */
  white-space: nowrap;
  /* outline: solid; */
  cursor: pointer;
  /* width: 10rem; */
  /* width: 100%;
  height: 100%; */
  /* font-size: 1rem; */
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  color: white;
  border-color: #2196f3;
  border: 1px solid #2196f3;

  /* Additional styles when button is disabled */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5; /* Adjust opacity as needed */
  }

  &:hover {
    color: #2196f3;
    font-weight: 500;
    background: linear-gradient(
      to bottom,
      var(--hover-color),
      var(--hover-color)
    );
  }
`;

export const SquireButton = styled.button`
  border-radius: 5px;
  background: linear-gradient(
    to bottom,
    var(--primary-color),
    var(--secondary-color)
  );
  margin: 10px 0px;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  /* width: 10rem; */
  font-size: 1rem;
  padding: 5px 15px;
  transition: ease color 250ms;
  overflow: hidden;
  color: var(--text-light-color);
  border: none;

  &:hover {
    color: var(--hover-text-color);
  }
`;

export const RoundButton = styled.button`
  border-radius: 50%;
  width: 100%;
  height: 100%;
  /* margin: 10px 0px; */
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  /* width: 10rem; */
  font-size: 1rem;
  /* padding: 5px 15px; */
  transition: ease color 250ms;
  overflow: hidden;
  color: var(--secondary-color);
  background-color: var(--text-light-color);
  border-width: 2px;
  border-color: var(--secondary-color);

  &:hover {
    color: var(--text-light-color);
    background-color: var(--secondary-color);
  }

  &:disabled {
    color: var(--text-light-color);
    background-color: var(--inactive-border-color);
    border: none;
  }
`;

// 23-Sep
export const InputFieldStyles = styled.input`
  width: 100%;
  height: 65%;
  padding: 0;
  margin: 0;
  border: 0;
  background-color: transparent;
  padding-left: 5px;
  font-size: 1rem;
  font-weight: 400;
  color: var(--primary-text-color);

  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputFieldLg = styled.input`
  width: 100%;
  height: 100%;
  /* min-width: 280px; */
  /* height: 20px; */
  padding: 0;
  margin: 0;
  border: 0;
  background-color: transparent;
  padding-left: 5px;
  /* font-family: "Inter", sans-serif; */
  font-size: 1rem;
  font-weight: 400;
  color: var(--primary-text-color);

  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputFieldExtraLg = styled.input`
  /* width: 100%; */
  /* min-width: 280px; */
  height: 20px;
  padding: 0;
  margin: 0;
  border: 0;
  background-color: transparent;
  padding-left: 5px;
  /* font-family: "Inter", sans-serif; */
  font-size: 1rem;
  font-weight: 400;
  color: var(--primary-text-color);
  &:focus {
    border: none;
    outline: none;
  }
`;

export const InputFieldSm = styled.input`
  width: 12%;
  min-width: 125px;
  height: 20px;
  padding: 0;
  margin: 0;
  border: 0;
  background-color: transparent;
  padding-left: 5px;
  /* padding: 16px 0px 0px 10px; */
  /* margin-top: 1rem;
  margin-bottom: 1rem; */
  /* font-family: "Inter", sans-serif; */
  font-size: 1rem;
  font-weight: 400;
  color: var(--primary-text-color);
  &:focus {
    border: none;
    outline: none;
  }
`;

// 23-Sep
export const Label = styled.label`
  width: 100%;
  height: 35%;
  padding-left: 0.3rem;
  margin: 0;
  font-family: "Roboto";
  font-size: 0.8rem;
  font-weight: 400;
  color: var(--secondary-color);
`;

export const PageLink = styled.div`
  color: white;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  color: var(--link-text-color);
  align-self: center;
  cursor: pointer;

  &:hover,
  &:focus {
    color: blue;
  }
  &:active {
    color: red;
  }
`;
